import React from 'react'
import UseAnimations from 'react-useanimations'
import infinity from 'react-useanimations/lib/infinity'
import { useTheme } from 'styled-components'
import { Flex } from '../Flex'

const Loading: React.FC<{ fullHeight?: boolean }> = ({ fullHeight }) => {
  const { colors } = useTheme()

  return (
    <Flex justifyContent="center" alignItems="center" padding={30} height={fullHeight ? '100%' : 'auto'}>
      <UseAnimations animation={infinity} strokeColor={colors.white} size={64} />
    </Flex>
  )
}

export default Loading
